import React, { useState, useEffect } from 'react';
import kanerikaLogo from '../assets/kanerika-logo.svg';
import { ChevronLeftIcon, ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/outline';
import { ScaleLoader } from 'react-spinners';
import { FINANICAL_LEVERS } from '../constants/general';
import Toast from './Toast';
import { toast } from 'react-toastify';
import Loader from './Loader';

function Sidebar({
  duration,
  setDuration,
  selectedDurationValue,
  setSelectedDurationValue,
  handleForecast,
  entities,
  setEntities,
  setIsLeverChanged,
  leversLoading,
  setMinimizeSidebar,
  financeTarget,
  setFinanceTarget,
  disableUpdateBtn,
  handleFinancialLevers,
  onReset,
  minimize = false,
}) {
  const [financialLeversByKey, setFinancialLeversByKey] = useState({});
  const [financialLevers, setFinancialLevers] = useState(entities);
  const [tempCOGSiscount, setTempCOGSiscount] = useState(null);
  const [tempAdvCOGS, setTempAdvCOGS] = useState(null);
  const [tempPromCOGS, setTempPromCOGS] = useState(null);
  const [tempAdvDiscount, setTempAdvDiscount] = useState(null);
  const [tempDiscount, setTempDiscount] = useState(null);
  const [tempADVDiscount, setTempADVDiscount] = useState(null);
  const [tempAdvValue, setTempAdvValue] = useState(null);
  const [tempADVDHoliday, setTempADVDHoliday] = useState(null);
  // const [toast, setToast] = useState({ show: false, message: '', type: '' });
  const [valueOptions, setValueOptions] = useState([]);
  const [isLeversExpanded, setLeversExpanded] = useState(true);
  const [isWhatIfExpanded, setIsWhatIfExpanded] = useState(true);

  useEffect(() => {
    setFinancialLevers(entities)
    setEntities(entities)
  }, [entities])

  useEffect(() => {
    financialLevers?.forEach((item, index) => {
      financialLeversByKey[item?.name] = { ...item, index: index }
    })
  }, [financialLevers])

  useEffect(() => {
    if (duration === 'Months') {
      setValueOptions(Array.from({ length: 12 }, (_, i) => i + 1));
    } else if (duration === 'Quarters') {
      setValueOptions(Array.from({ length: 4 }, (_, i) => i + 1));
    } else if (duration === 'Year') {
      setValueOptions([1]);
    }
    setSelectedDurationValue(1);
  }, [duration]);

  // useEffect(() => {
  //   setMinimizeSidebar(minimize)
  // }, [minimize])


  // Function to show toast notifications
  // const showToast = (message, type) => {
  //   setToast({ show: true, message, type });

  //   // Automatically close the toast after 3 seconds
  //   setTimeout(() => {
  //     setToast({ show: false, message: '', type: '' });
  //   }, 5000);
  // };

  useEffect(() => {
    if (duration === '12M') {
      setValueOptions(Array.from({ length: 12 }, (_, i) => i + 1)); // 1-12 for months
    } else if (duration === '4Q') {
      setValueOptions(Array.from({ length: 4 }, (_, i) => i + 1)); // 1-4 for quarters
    } else if (duration === '1Y') {
      setValueOptions([1]); // Only 1 for a year
    }
  }, [duration]);

  const formatValue = (value) => {
    if (typeof value === 'number' && !Number.isInteger(value)) {
      // If the value is a decimal, apply toFixed() to round it to 2 decimal places
      return value.toFixed(2);
    }
    // For integers or non-number types, return the value as is
    return value;
  };
  useEffect(() => {
    if (leversLoading) {
      setLeversExpanded(true)
    }
  }, [leversLoading])

  // const handleEntityChange = (index, value, entityName) => {
  //   const updatedEntities = entities
  //   const currentValue = value;
  //   console.log('handleEntityChange', index, value, entityName)
  //   if(entityName === FINANICAL_LEVERS.COGS) {
  //     const diff = currentValue - entities[index].value;
  //     if(financialLeversByKey[FINANICAL_LEVERS.TARGET]?.frozen == false) {
  //       const targetValue = updatedEntities[financialLeversByKey[FINANICAL_LEVERS.TARGET]['index']]['value']
  //       if(financialLeversByKey[FINANICAL_LEVERS.SALES]?.frozen == false) {

  //         const salesValue = updatedEntities[financialLeversByKey[FINANICAL_LEVERS.SALES]['index']]['value']
  //         updatedEntities[financialLeversByKey[FINANICAL_LEVERS.TARGET]['index']]['value'] = targetValue + ( diff * 0.75 )
  //         updatedEntities[financialLeversByKey[FINANICAL_LEVERS.SALES]['index']]['value'] = salesValue + diff
  //       } else {
  //         updatedEntities[financialLeversByKey[FINANICAL_LEVERS.TARGET]['index']]['value'] = targetValue - ( diff * 0.75 )
  //       }
  //     } else {

  //     }
  //   }
  //   // const updatedEntities = entities.map((entity, i) =>
  //   //   i === index ? { ...entity, value: value } : entity
  //   // );
  //   console.log(updatedEntities)
  //   setEntities(updatedEntities)
  // };

  const handleEntityChange = (index, value, entityName) => {
    // Clone the financialLevers array to ensure immutability
    const updatedEntities = [...financialLevers]; // Create a new array with the same elements

    const currentEntity = updatedEntities[index]; // Get the current entity by index

    // Update the current entity's value
    updatedEntities[index] = { ...currentEntity, value };
    const targetIndex = financialLeversByKey[FINANICAL_LEVERS.TARGET].index;
    const targetValue = Number(updatedEntities[targetIndex].value);
    const salesIndex = financialLeversByKey[FINANICAL_LEVERS.SALES].index;
    const salesValue = Number(updatedEntities[salesIndex].value);
    const cogsIndex = financialLeversByKey[FINANICAL_LEVERS.COGS].index;
    const cogsValue = Number(updatedEntities[cogsIndex].value);
    const discountIndex = financialLeversByKey[FINANICAL_LEVERS.DISCOUNT].index;
    const discountValue = Number(updatedEntities[discountIndex].value);
    const adCostIndex = financialLeversByKey[FINANICAL_LEVERS.ADVERTISEMENT_COST].index;
    const adCostValue = Number(updatedEntities[adCostIndex].value);
    const promIndex = financialLeversByKey[FINANICAL_LEVERS.PROMOTION_DAYS].index;
    const promValue = Number(updatedEntities[promIndex].value);


    if (entityName === FINANICAL_LEVERS.COGS) {
      const targetIndex = financialLeversByKey[FINANICAL_LEVERS.TARGET].index;
      const targetValue = Number(updatedEntities[targetIndex].value);
      const salesIndex = financialLeversByKey[FINANICAL_LEVERS.SALES].index;
      const salesValue = Number(updatedEntities[salesIndex].value);
      const cogsIndex = financialLeversByKey[FINANICAL_LEVERS.COGS].index;
      const cogsValue = Number(updatedEntities[cogsIndex].value);
      const discountIndex = financialLeversByKey[FINANICAL_LEVERS.DISCOUNT].index;
      const discountValue = Number(updatedEntities[discountIndex].value);
      const adCostIndex = financialLeversByKey[FINANICAL_LEVERS.ADVERTISEMENT_COST].index;
      const adCostValue = Number(updatedEntities[adCostIndex].value);
      const promIndex = financialLeversByKey[FINANICAL_LEVERS.PROMOTION_DAYS].index;
      const promValue = Number(updatedEntities[promIndex].value);
      const diff = value - currentEntity.value;
      if (!financialLeversByKey[FINANICAL_LEVERS.TARGET]?.frozen) {
        // const targetIndex = financialLeversByKey[FINANICAL_LEVERS.TARGET].index;
        // const targetValue = Number(updatedEntities[targetIndex].value);

        if (!financialLeversByKey[FINANICAL_LEVERS.SALES]?.frozen) {
          // const salesIndex = financialLeversByKey[FINANICAL_LEVERS.SALES].index;
          // const salesValue = Number(updatedEntities[salesIndex].value);
          // const discountIndex = financialLeversByKey[FINANICAL_LEVERS.DISCOUNT].index;
          // const discountValue = Number(updatedEntities[discountIndex].value);

          // Update target and sales with new values
          updatedEntities[targetIndex] = {
            ...updatedEntities[targetIndex],
            value: formatValue(Number(updatedEntities[targetIndex]['value']) + diff * 0.75),
          };
          // updatedEntities[discountIndex] = {
          //   ...updatedEntities[discountIndex],
          //   value: formatValue(discountValue + diff * 0.75),
          // };

          updatedEntities[salesIndex] = {
            ...updatedEntities[salesIndex],
            value: formatValue(Number(updatedEntities[salesIndex]['value']) + diff),
          };
        } else {
          // Only update the target value if sales is frozen
          updatedEntities[targetIndex] = {
            ...updatedEntities[targetIndex],
            value: formatValue(Number(updatedEntities[targetIndex]['value']) - diff * 0.75),
          };
        }
      } else {
        // const discountIndex = financialLeversByKey[FINANICAL_LEVERS.DISCOUNT].index;
        // const discountValue = Number(updatedEntities[discountIndex].value);

        if (!financialLeversByKey[FINANICAL_LEVERS.DISCOUNT]?.frozen) {
          if (discountValue === 0 && !tempCOGSiscount) {
            setTempCOGSiscount(value)
          }
          if (parseInt(value, 10) < parseInt(tempCOGSiscount, 10)) {
            updatedEntities[discountIndex] = {
              ...updatedEntities[discountIndex],
              value: formatValue(Number(updatedEntities[discountIndex]['value']) + diff * 0.01),
            };
          }
          if ((parseInt(value, 10) >= parseInt(tempCOGSiscount, 10)) && tempCOGSiscount) {
            updatedEntities[discountIndex] = {
              ...updatedEntities[discountIndex],
              value: 0,
            };
          }
          if (!tempCOGSiscount) {
            updatedEntities[discountIndex] = {
              ...updatedEntities[discountIndex],
              value: formatValue(Number(updatedEntities[discountIndex]['value']) + diff * 0.05),
            };
          }
        }

        if (!financialLeversByKey[FINANICAL_LEVERS.ADVERTISEMENT_COST]?.frozen) {
          // const adCostIndex = financialLeversByKey[FINANICAL_LEVERS.ADVERTISEMENT_COST].index;
          // const adCostValue = Number(updatedEntities[adCostIndex].value);

          if (adCostValue === 0 && !tempAdvCOGS) {
            setTempAdvCOGS(value)
          }
          if (parseInt(value, 10) < parseInt(tempAdvCOGS, 10)) {
            updatedEntities[adCostIndex] = {
              ...updatedEntities[adCostIndex],
              value: formatValue(Number(updatedEntities[adCostIndex]['value']) + (Number(updatedEntities[adCostIndex]['value']) * 0.1 * diff)),
            };
          }
          if ((parseInt(value, 10) >= parseInt(tempAdvCOGS, 10)) && tempAdvCOGS) {
            updatedEntities[adCostIndex] = {
              ...updatedEntities[adCostIndex],
              value: 0,
            };
          }
          if (!tempAdvCOGS) {
            updatedEntities[adCostIndex] = {
              ...updatedEntities[adCostIndex],
              value: formatValue(Number(updatedEntities[adCostIndex]['value']) + (Number(updatedEntities[adCostIndex]['value']) * 0.1 * diff)),
            };
          }

        }

        if (!financialLeversByKey[FINANICAL_LEVERS.PROMOTION_DAYS]?.frozen) {
          // const promIndex = financialLeversByKey[FINANICAL_LEVERS.PROMOTION_DAYS].index;
          // const promValue = Number(updatedEntities[promIndex].value);

          if (promValue === 0 && !tempPromCOGS) {
            setTempPromCOGS(value)
          }
          if (parseInt(value, 10) < parseInt(tempPromCOGS, 10)) {
            updatedEntities[promIndex] = {
              ...updatedEntities[promIndex],
              value: formatValue(Number(updatedEntities[promIndex]['value']) + 0.1 * diff),
            };
          }
          if ((parseInt(value, 10) >= parseInt(tempPromCOGS, 10)) && tempPromCOGS) {
            updatedEntities[promIndex] = {
              ...updatedEntities[promIndex],
              value: 0,
            };
          }
          if (!tempPromCOGS) {
            updatedEntities[promIndex] = {
              ...updatedEntities[promIndex],
              value: formatValue(Number(updatedEntities[promIndex]['value']) + 0.1 * diff),
            };
          }

        }

      }

      updatedEntities[salesIndex] = {
        ...updatedEntities[salesIndex],
        value: Math.max(Number(updatedEntities[salesIndex]['value']), 0),
      };

      updatedEntities[cogsIndex] = {
        ...updatedEntities[cogsIndex],
        value: Math.max(Number(updatedEntities[cogsIndex]['value']), 0),
      };

      updatedEntities[discountIndex] = {
        ...updatedEntities[discountIndex],
        value: Math.max(Number(updatedEntities[discountIndex]['value']), 0),
      };

      updatedEntities[adCostIndex] = {
        ...updatedEntities[adCostIndex],
        value: Math.max(Number(updatedEntities[adCostIndex]['value']), 0),
      };

      updatedEntities[promIndex] = {
        ...updatedEntities[promIndex],
        value: Math.max(Number(updatedEntities[promIndex]['value']), 0),
      };
    }

    if (entityName === FINANICAL_LEVERS.DISCOUNT) {
      const diff = value - currentEntity.value;

      if (!financialLeversByKey[FINANICAL_LEVERS.TARGET]?.frozen) {
        if (financialLeversByKey[FINANICAL_LEVERS.SALES]?.frozen || financialLeversByKey[FINANICAL_LEVERS.COGS]?.frozen) {
          updatedEntities[salesIndex] = {
            ...updatedEntities[salesIndex],
            frozen: false,
          };
          updatedEntities[cogsIndex] = {
            ...updatedEntities[cogsIndex],
            frozen: false,
          };
          toast.info('Sales and COGS should be enabled for Discount')
          // showToast("Sales and COGS should be enabled for Discount", "info")

          // Show notification to the user Sales and cogs should be enabled for Discount
        }

        updatedEntities[targetIndex] = {
          ...updatedEntities[targetIndex],
          value: formatValue(Number(updatedEntities[targetIndex]['value']) + diff * 1.4),
        };

        updatedEntities[salesIndex] = {
          ...updatedEntities[salesIndex],
          value: formatValue(Number(updatedEntities[salesIndex]['value']) + diff * 1.4),
        };

        updatedEntities[cogsIndex] = {
          ...updatedEntities[cogsIndex],
          value: formatValue(Number(updatedEntities[cogsIndex]['value']) + diff * 1.4),
        };


        if (!financialLeversByKey[FINANICAL_LEVERS.ADVERTISEMENT_COST]?.frozen) {
          if (adCostValue === 0 && !tempAdvDiscount) {
            setTempAdvDiscount(value)
          }
          if (parseInt(value, 10) < parseInt(tempAdvDiscount, 10)) {
            updatedEntities[adCostIndex] = {
              ...updatedEntities[adCostIndex],
              value: formatValue(Number(updatedEntities[adCostIndex]['value']) - (1000 * diff)),
            };
          }
          if ((parseInt(value, 10) >= parseInt(tempAdvDiscount, 10)) && tempAdvDiscount) {
            updatedEntities[adCostIndex] = {
              ...updatedEntities[adCostIndex],
              value: 0,
            };
          }
          if (!tempAdvDiscount) {
            updatedEntities[adCostIndex] = {
              ...updatedEntities[adCostIndex],
              value: formatValue(Number(updatedEntities[adCostIndex]['value']) - (1000 * diff)),
            };
          }
        }

        if (!financialLeversByKey[FINANICAL_LEVERS.PROMOTION_DAYS]?.frozen) {
          if (promValue === 0 && tempDiscount) {
            setTempDiscount(value)
          }
          if (parseInt(value, 10) < parseInt(tempDiscount, 10)) {
            updatedEntities[promIndex] = {
              ...updatedEntities[promIndex],
              value: formatValue(Number(updatedEntities[promIndex]['value']) - Math.floor(diff)),
            };
          }
          if ((parseInt(value, 10) >= parseInt(tempDiscount, 10)) && tempDiscount) {
            updatedEntities[promIndex] = {
              ...updatedEntities[promIndex],
              value: 0,
            };
          }
          if (!tempDiscount) {
            updatedEntities[promIndex] = {
              ...updatedEntities[promIndex],
              value: formatValue(Number(updatedEntities[promIndex]['value']) - Math.floor(diff)),
            };
          }
        }
      } else {
        if (financialLeversByKey[FINANICAL_LEVERS.SALES]?.frozen && financialLeversByKey[FINANICAL_LEVERS.COGS]?.frozen) {
          if (!financialLeversByKey[FINANICAL_LEVERS.ADVERTISEMENT_COST]?.frozen) {
            if (adCostValue === 0 && tempAdvDiscount) {
              setTempAdvDiscount(value)
            } if (parseInt(value, 10) < parseInt(tempAdvDiscount, 10)) {
              updatedEntities[adCostIndex] = {
                ...updatedEntities[adCostIndex],
                value: formatValue(Number(updatedEntities[adCostIndex]['value']) - (1000 * diff)),
              };
            } if ((parseInt(value, 10) >= parseInt(tempAdvDiscount, 10)) && tempAdvDiscount) {
              updatedEntities[adCostIndex] = {
                ...updatedEntities[adCostIndex],
                value: 0,
              };
            } if (!tempAdvDiscount) {
              updatedEntities[adCostIndex] = {
                ...updatedEntities[adCostIndex],
                value: formatValue(Number(updatedEntities[adCostIndex]['value']) - (1000 * diff)),
              };
            }
          }

          if (!financialLeversByKey[FINANICAL_LEVERS.PROMOTION_DAYS]?.frozen) {
            if (promValue === 0 && tempDiscount) {
              setTempDiscount(value)
            }
            if (parseInt(value, 10) < parseInt(tempDiscount, 10)) {
              updatedEntities[promIndex] = {
                ...updatedEntities[promIndex],
                value: formatValue(Number(updatedEntities[promIndex]['value']) - Math.floor(diff)),
              };
            }
            if ((parseInt(value, 10) >= parseInt(tempDiscount, 10)) && tempDiscount) {
              updatedEntities[promIndex] = {
                ...updatedEntities[promIndex],
                value: 0,
              };
            }
            if (!tempDiscount) {
              updatedEntities[promIndex] = {
                ...updatedEntities[promIndex],
                value: formatValue(Number(updatedEntities[promIndex]['value']) - Math.floor(diff)),
              };
            }
          }
        } else {
          if (financialLeversByKey[FINANICAL_LEVERS.SALES]?.frozen || financialLeversByKey[FINANICAL_LEVERS.COGS]?.frozen) {
            updatedEntities[salesIndex] = {
              ...updatedEntities[salesIndex],
              frozen: false,
            };
            updatedEntities[cogsIndex] = {
              ...updatedEntities[cogsIndex],
              frozen: false,
            };
             toast.info("Sales and COGS should be active")
            // showToast("Sales and COGS should be active", "info")
            //Show notification to user Sales and cogs both should be active
          }
          // showToast("Target should be active if Sales and COGS active", "info")
          toast.info("Target should be active if Sales and COGS active")
          //Show notification to user Target should be active if sales and cogs active
          updatedEntities[targetIndex] = {
            ...updatedEntities[targetIndex],
            frozen: false,
          };

          updatedEntities[targetIndex] = {
            ...updatedEntities[targetIndex],
            value: formatValue(Number(updatedEntities[targetIndex]['value']) + diff * 0.8),
          };

          updatedEntities[salesIndex] = {
            ...updatedEntities[salesIndex],
            value: formatValue(Number(updatedEntities[salesIndex]['value']) + diff * 0.8),
          };

          updatedEntities[cogsIndex] = {
            ...updatedEntities[cogsIndex],
            value: formatValue(Number(updatedEntities[cogsIndex]['value']) + diff * 0.8),
          };

        }
      }

      updatedEntities[salesIndex] = {
        ...updatedEntities[salesIndex],
        value: formatValue(Math.max(Number(updatedEntities[salesIndex]['value']), 0)),
      };

      updatedEntities[cogsIndex] = {
        ...updatedEntities[cogsIndex],
        value: formatValue(Math.max(Number(updatedEntities[cogsIndex]['value']), 0)),
      };

      updatedEntities[discountIndex] = {
        ...updatedEntities[discountIndex],
        value: formatValue(Math.max(Number(updatedEntities[discountIndex]['value']), 0)),
      };

      updatedEntities[adCostIndex] = {
        ...updatedEntities[adCostIndex],
        value: formatValue(Math.max(Number(updatedEntities[adCostIndex]['value']), 0)),
      };

      updatedEntities[promIndex] = {
        ...updatedEntities[promIndex],
        value: formatValue(Math.max(Number(updatedEntities[promIndex]['value']), 0)),
      };

      updatedEntities[promIndex] = {
        ...updatedEntities[promIndex],
        value: formatValue(Math.min(Number(updatedEntities[promIndex]['value']), 15)),
      };
    }

    if (entityName === FINANICAL_LEVERS.ADVERTISEMENT_COST) {
      const targetIndex = financialLeversByKey[FINANICAL_LEVERS.TARGET].index;
      const targetValue = Number(updatedEntities[targetIndex].value);
      const salesIndex = financialLeversByKey[FINANICAL_LEVERS.SALES].index;
      const salesValue = Number(updatedEntities[salesIndex].value);
      const cogsIndex = financialLeversByKey[FINANICAL_LEVERS.COGS].index;
      const cogsValue = Number(updatedEntities[cogsIndex].value);
      const discountIndex = financialLeversByKey[FINANICAL_LEVERS.DISCOUNT].index;
      const discountValue = Number(updatedEntities[discountIndex].value);
      const adCostIndex = financialLeversByKey[FINANICAL_LEVERS.ADVERTISEMENT_COST].index;
      const adCostValue = Number(updatedEntities[adCostIndex].value);
      const promIndex = financialLeversByKey[FINANICAL_LEVERS.PROMOTION_DAYS].index;
      const promValue = Number(updatedEntities[promIndex].value);

      const diff = (value - currentEntity.value) / 10_000;

      if (!financialLeversByKey[FINANICAL_LEVERS.TARGET]?.frozen) {
        if (financialLeversByKey[FINANICAL_LEVERS.SALES]?.frozen || financialLeversByKey[FINANICAL_LEVERS.COGS]?.frozen) {
          updatedEntities[salesIndex] = {
            ...updatedEntities[salesIndex],
            frozen: false,
          };
          updatedEntities[cogsIndex] = {
            ...updatedEntities[cogsIndex],
            frozen: false,
          };
          toast.info("Sales and COGS should be active for Advertisements")
          // showToast("Sales and COGS should be active for Advertisements", "info")
          // Show notification to user, Sales and cogs should be active for Advertisements
        }

        updatedEntities[targetIndex] = {
          ...updatedEntities[targetIndex],
          value: formatValue(Number(updatedEntities[targetIndex]['value']) + diff * 0.8),
        };

        updatedEntities[salesIndex] = {
          ...updatedEntities[salesIndex],
          value: formatValue(Number(updatedEntities[salesIndex]['value']) + diff * 0.8),
        };

        updatedEntities[cogsIndex] = {
          ...updatedEntities[cogsIndex],
          value: formatValue(Number(updatedEntities[cogsIndex]['value']) + diff * 0.8),
        };

        if (!financialLeversByKey[FINANICAL_LEVERS.DISCOUNT]?.frozen) {
          if (Number(updatedEntities[discountIndex]['value']) === 0 && !tempADVDiscount) {
            setTempADVDiscount(value)
          } if (parseInt(value, 10) < parseInt(tempADVDiscount, 10)) {
            updatedEntities[discountIndex] = {
              ...updatedEntities[discountIndex],
              value: formatValue(Number(updatedEntities[discountIndex]['value']) - diff),
            };
          } if ((parseInt(value, 10) >= parseInt(tempADVDiscount, 10)) && tempADVDiscount) {
            updatedEntities[discountIndex] = {
              ...updatedEntities[discountIndex],
              value: 0,
            };
          } if (!tempADVDiscount) {
            updatedEntities[discountIndex] = {
              ...updatedEntities[discountIndex],
              value: formatValue(Number(updatedEntities[discountIndex]['value']) - diff),
            };
          }
          // this.DiscountMax = Number(updatedEntities[discountIndex]['value'])
        }

        if (!financialLeversByKey[FINANICAL_LEVERS.PROMOTION_DAYS]?.frozen) {
          if (Number(updatedEntities[promIndex]['value']) === 0 && !tempAdvValue) {
            setTempAdvValue(value)
          } if (parseInt(value, 10) < parseInt(tempAdvValue, 10)) {
            updatedEntities[promIndex] = {
              ...updatedEntities[promIndex],
              value: formatValue(Number(updatedEntities[promIndex]['value']) - diff),
            };
          } if ((parseInt(value, 10) >= parseInt(tempAdvValue, 10)) && tempAdvValue) {
            updatedEntities[promIndex] = {
              ...updatedEntities[promIndex],
              value: 0,
            };
          } if (!tempAdvValue) {
            updatedEntities[promIndex] = {
              ...updatedEntities[promIndex],
              value: formatValue(Number(updatedEntities[promIndex]['value']) - diff),
            };
          }
          // Number(updatedEntities[promIndex]['value']) = this.HolidaysMax
        }

      } else {
        if (financialLeversByKey[FINANICAL_LEVERS.SALES]?.frozen || financialLeversByKey[FINANICAL_LEVERS.COGS]?.frozen) {
          if (!financialLeversByKey[FINANICAL_LEVERS.DISCOUNT]?.frozen) {
            if (Number(updatedEntities[discountIndex]['value']) === 0 && !tempADVDiscount) {
              setTempADVDiscount(value)
            } if (parseInt(value, 10) < parseInt(tempADVDiscount, 10)) {
              updatedEntities[discountIndex] = {
                ...updatedEntities[discountIndex],
                value: formatValue(Number(updatedEntities[discountIndex]['value']) - diff),
              };
            } if ((parseInt(value, 10) >= parseInt(tempADVDiscount, 10)) && tempADVDiscount) {
              updatedEntities[discountIndex] = {
                ...updatedEntities[discountIndex],
                value: 0,
              };
            } if (!tempADVDiscount) {
              updatedEntities[discountIndex] = {
                ...updatedEntities[discountIndex],
                value: formatValue(Number(updatedEntities[discountIndex]['value']) - diff),
              };
            }
            // this.DiscountMax = Number(updatedEntities[discountIndex]['value'])
          }

          if (!financialLeversByKey[FINANICAL_LEVERS.PROMOTION_DAYS]?.frozen) {
            if (Number(updatedEntities[promIndex]['value']) === 0 && !tempAdvValue) {
              setTempAdvValue(value)
            } if (parseInt(value, 10) < parseInt(tempAdvValue, 10)) {
              updatedEntities[promIndex] = {
                ...updatedEntities[promIndex],
                value: formatValue(Number(updatedEntities[promIndex]['value']) - diff),
              };
            } if ((parseInt(value, 10) >= parseInt(tempAdvValue, 10)) && tempAdvValue) {
              updatedEntities[promIndex] = {
                ...updatedEntities[promIndex],
                value: 0,
              };
            } if (!tempAdvValue) {
              updatedEntities[promIndex] = {
                ...updatedEntities[promIndex],
                value: formatValue(Number(updatedEntities[promIndex]['value']) - diff),
              };
            }
            // Number(updatedEntities[promIndex]['value']) = this.HolidaysMax
          }
        } else {
          if (financialLeversByKey[FINANICAL_LEVERS.SALES]?.frozen || financialLeversByKey[FINANICAL_LEVERS.COGS]?.frozen) {
            updatedEntities[salesIndex] = {
              ...updatedEntities[salesIndex],
              frozen: false,
            };
            updatedEntities[cogsIndex] = {
              ...updatedEntities[cogsIndex],
              frozen: false,
            };
            toast.info("Sales and COGS should be active")
            // showToast("Sales and COGS should be active", "info")

            // Show notification to user, Sales and cogs both should be active
          }
          toast.info("Target should be active if Sales and COGS are active")
          // showToast("Target should be active if Sales and COGS are active", "info")
          // Show notification to user, Target should be active if sales and cogs active

          updatedEntities[targetIndex] = {
            ...updatedEntities[targetIndex],
            frozen: false,
          };

          updatedEntities[targetIndex] = {
            ...updatedEntities[targetIndex],
            value: formatValue(Number(updatedEntities[targetIndex]['value']) + diff * 0.8),
          };

          updatedEntities[salesIndex] = {
            ...updatedEntities[salesIndex],
            value: formatValue(Number(updatedEntities[salesIndex]['value']) + diff * 0.8),
          };

          updatedEntities[cogsIndex] = {
            ...updatedEntities[cogsIndex],
            value: formatValue(Number(updatedEntities[cogsIndex]['value']) + diff * 0.8),
          };

          if (!financialLeversByKey[FINANICAL_LEVERS.DISCOUNT]?.frozen) {
            if (Number(updatedEntities[discountIndex]['value']) === 0 && !tempADVDiscount) {
              setTempADVDiscount(value)
            } if (parseInt(value, 10) < parseInt(tempADVDiscount, 10)) {
              updatedEntities[discountIndex] = {
                ...updatedEntities[discountIndex],
                value: formatValue(Number(updatedEntities[discountIndex]['value']) - diff),
              };
            } if ((parseInt(value, 10) >= parseInt(tempADVDiscount, 10)) && tempADVDiscount) {
              updatedEntities[discountIndex] = {
                ...updatedEntities[discountIndex],
                value: 0,
              };
            } if (!tempADVDiscount) {
              updatedEntities[discountIndex] = {
                ...updatedEntities[discountIndex],
                value: formatValue(Number(updatedEntities[discountIndex]['value']) - diff),
              };
            }
            // this.DiscountMax = Number(updatedEntities[discountIndex]['value'])
          }

          if (!financialLeversByKey[FINANICAL_LEVERS.PROMOTION_DAYS]?.frozen) {
            if (Number(updatedEntities[promIndex]['value']) === 0 && !tempAdvValue) {
              setTempAdvValue(value)
            } if (parseInt(value, 10) < parseInt(tempAdvValue, 10)) {
              updatedEntities[promIndex] = {
                ...updatedEntities[promIndex],
                value: formatValue(Number(updatedEntities[promIndex]['value']) - Math.floor(diff)),
              };
            } if ((parseInt(value, 10) >= parseInt(tempAdvValue, 10)) && tempAdvValue) {
              updatedEntities[promIndex] = {
                ...updatedEntities[promIndex],
                value: 0,
              };
            } if (!tempAdvValue) {
              updatedEntities[promIndex] = {
                ...updatedEntities[promIndex],
                value: formatValue(Number(updatedEntities[promIndex]['value']) - Math.floor(diff)),
              };
            }
            // Number(updatedEntities[promIndex]['value']) = this.HolidaysMax
          }


        }
      }

      updatedEntities[salesIndex] = {
        ...updatedEntities[salesIndex],
        value: formatValue(Math.max(Number(updatedEntities[salesIndex]['value']), 0)),
      };

      updatedEntities[cogsIndex] = {
        ...updatedEntities[cogsIndex],
        value: formatValue(Math.max(Number(updatedEntities[cogsIndex]['value']), 0)),
      };

      updatedEntities[discountIndex] = {
        ...updatedEntities[discountIndex],
        value: formatValue(Math.max(Number(updatedEntities[discountIndex]['value']), 0)),
      };

      updatedEntities[adCostIndex] = {
        ...updatedEntities[adCostIndex],
        value: formatValue(Math.max(Number(updatedEntities[adCostIndex]['value']), 0)),
      };

      updatedEntities[promIndex] = {
        ...updatedEntities[promIndex],
        value: formatValue(Math.min(Number(updatedEntities[promIndex]['value']), 30)),
      };

      updatedEntities[promIndex] = {
        ...updatedEntities[promIndex],
        value: formatValue(Math.max(Number(updatedEntities[promIndex]['value']), 0)),
      };

    }

    if (entityName === FINANICAL_LEVERS.PROMOTION_DAYS) {
      const targetIndex = financialLeversByKey[FINANICAL_LEVERS.TARGET].index;
      const targetValue = Number(updatedEntities[targetIndex].value);
      const salesIndex = financialLeversByKey[FINANICAL_LEVERS.SALES].index;
      const salesValue = Number(updatedEntities[salesIndex].value);
      const cogsIndex = financialLeversByKey[FINANICAL_LEVERS.COGS].index;
      const cogsValue = Number(updatedEntities[cogsIndex].value);
      const discountIndex = financialLeversByKey[FINANICAL_LEVERS.DISCOUNT].index;
      const discountValue = Number(updatedEntities[discountIndex].value);
      const adCostIndex = financialLeversByKey[FINANICAL_LEVERS.ADVERTISEMENT_COST].index;
      const adCostValue = Number(updatedEntities[adCostIndex].value);
      const promIndex = financialLeversByKey[FINANICAL_LEVERS.PROMOTION_DAYS].index;
      const promValue = Number(updatedEntities[promIndex].value);

      const diff = value - currentEntity.value;

      if (!financialLeversByKey[FINANICAL_LEVERS.TARGET]?.frozen) {
        if (financialLeversByKey[FINANICAL_LEVERS.SALES]?.frozen || financialLeversByKey[FINANICAL_LEVERS.COGS]?.frozen) {
          updatedEntities[salesIndex] = {
            ...updatedEntities[salesIndex],
            frozen: false,
          };
          updatedEntities[cogsIndex] = {
            ...updatedEntities[cogsIndex],
            frozen: false,
          };
          toast.info("Sales and COGS should be active for Promotions");
          // showToast("Sales and COGS should be active for Promotions", "info")
          // Show notification to user, Sales and cogs should be active for promotions
        }

        updatedEntities[targetIndex] = {
          ...updatedEntities[targetIndex],
          value: formatValue(Number(updatedEntities[targetIndex]['value']) + diff * 1.2),
        };

        updatedEntities[salesIndex] = {
          ...updatedEntities[salesIndex],
          value: formatValue(Number(updatedEntities[salesIndex]['value']) + diff * 1.2),
        };

        updatedEntities[cogsIndex] = {
          ...updatedEntities[cogsIndex],
          value: formatValue(Number(updatedEntities[cogsIndex]['value']) + diff * 1.2),
        };

        if (!financialLeversByKey[FINANICAL_LEVERS.ADVERTISEMENT_COST]?.frozen) {
          if (Number(updatedEntities[adCostIndex]['value']) === 0 && !tempADVDHoliday) {
            setTempADVDHoliday(value)
          } if (parseInt(value, 10) < parseInt(tempADVDHoliday, 10)) {
            updatedEntities[adCostIndex] = {
              ...updatedEntities[adCostIndex],
              value: formatValue(Number(updatedEntities[adCostIndex]['value']) - diff * 1800),
            };
          } if ((parseInt(value, 10) >= parseInt(tempADVDHoliday, 10)) && tempADVDHoliday) {
            updatedEntities[adCostIndex] = {
              ...updatedEntities[adCostIndex],
              value: 0,
            };
          } if (!tempADVDHoliday) {
            updatedEntities[adCostIndex] = {
              ...updatedEntities[adCostIndex],
              value: formatValue(Number(updatedEntities[adCostIndex]['value']) - diff * 1800),
            };
          }
        }


        if (!financialLeversByKey[FINANICAL_LEVERS.DISCOUNT]?.frozen) {
          if (Number(updatedEntities[discountIndex]['value']) === 0 && !tempADVDiscount) {
            setTempADVDiscount(value)
          } if (parseInt(value, 10) < parseInt(tempADVDiscount, 10)) {
            updatedEntities[discountIndex] = {
              ...updatedEntities[discountIndex],
              value: formatValue(Number(updatedEntities[discountIndex]['value']) - diff),
            };
          } if ((parseInt(value, 10) >= parseInt(tempADVDiscount, 10)) && tempADVDiscount) {
            updatedEntities[discountIndex] = {
              ...updatedEntities[discountIndex],
              value: 0,
            };
          } if (!tempADVDiscount) {
            updatedEntities[discountIndex] = {
              ...updatedEntities[discountIndex],
              value: formatValue(Number(updatedEntities[discountIndex]['value']) - diff),
            };
          }
          // this.DiscountMax = Number(updatedEntities[discountIndex]['value'])
        }
      } else {
        if (financialLeversByKey[FINANICAL_LEVERS.SALES]?.frozen || financialLeversByKey[FINANICAL_LEVERS.COGS]?.frozen) {
          if (!financialLeversByKey[FINANICAL_LEVERS.ADVERTISEMENT_COST]?.frozen) {
            if (Number(updatedEntities[adCostIndex]['value']) === 0 && !tempADVDHoliday) {
              setTempADVDHoliday(value)
            } if (parseInt(value, 10) < parseInt(tempADVDHoliday, 10)) {
              updatedEntities[adCostIndex] = {
                ...updatedEntities[adCostIndex],
                value: formatValue(Number(updatedEntities[adCostIndex]['value']) - diff * 1800),
              };
            } if ((parseInt(value, 10) >= parseInt(tempADVDHoliday, 10)) && tempADVDHoliday) {
              updatedEntities[adCostIndex] = {
                ...updatedEntities[adCostIndex],
                value: 0,
              };
            } if (!tempADVDHoliday) {
              updatedEntities[adCostIndex] = {
                ...updatedEntities[adCostIndex],
                value: formatValue(Number(updatedEntities[adCostIndex]['value']) - diff * 1800),
              };
            }
          }

          if (!financialLeversByKey[FINANICAL_LEVERS.DISCOUNT]?.frozen) {
            if (Number(updatedEntities[discountIndex]['value']) === 0 && !tempADVDiscount) {
              setTempADVDiscount(value)
            } if (parseInt(value, 10) < parseInt(tempADVDiscount, 10)) {
              updatedEntities[discountIndex] = {
                ...updatedEntities[discountIndex],
                value: formatValue(Number(updatedEntities[discountIndex]['value']) - diff),
              };
            } if ((parseInt(value, 10) >= parseInt(tempADVDiscount, 10)) && tempADVDiscount) {
              updatedEntities[discountIndex] = {
                ...updatedEntities[discountIndex],
                value: 0,
              };
            } if (!tempADVDiscount) {
              updatedEntities[discountIndex] = {
                ...updatedEntities[discountIndex],
                value: formatValue(Number(updatedEntities[discountIndex]['value']) - diff),
              };
            }
            // this.DiscountMax = Number(updatedEntities[discountIndex]['value'])
          }
        } else {
          if (financialLeversByKey[FINANICAL_LEVERS.SALES]?.frozen || financialLeversByKey[FINANICAL_LEVERS.COGS]?.frozen) {
            updatedEntities[salesIndex] = {
              ...updatedEntities[salesIndex],
              frozen: false,
            };
            updatedEntities[cogsIndex] = {
              ...updatedEntities[cogsIndex],
              frozen: false,
            };
             toast.info("Sales and COGS both should be active")
            // showToast("Sales and COGS both should be active", "info")
            // Show notification to user, Sales and cogs both should be active
          }
          toast.info("arget should be active if Sales and COGS are active")
          // showToast("Target should be active if Sales and COGS are active", "info")
          // Show notification to user, Target should be active if sales and cogs active
          updatedEntities[targetIndex] = {
            ...updatedEntities[targetIndex],
            frozen: false,
          };

          updatedEntities[targetIndex] = {
            ...updatedEntities[targetIndex],
            value: formatValue(Number(updatedEntities[targetIndex]['value']) + diff * 1.2),
          };

          updatedEntities[salesIndex] = {
            ...updatedEntities[salesIndex],
            value: formatValue(Number(updatedEntities[salesIndex]['value']) + diff * 1.2),
          };

          updatedEntities[cogsIndex] = {
            ...updatedEntities[cogsIndex],
            value: formatValue(Number(updatedEntities[cogsIndex]['value']) + diff * 1.2),
          };
        }
      }

      updatedEntities[salesIndex] = {
        ...updatedEntities[salesIndex],
        value: formatValue(Math.max(Number(updatedEntities[salesIndex]['value']), 0)),
      };

      updatedEntities[cogsIndex] = {
        ...updatedEntities[cogsIndex],
        value: formatValue(Math.max(Number(updatedEntities[cogsIndex]['value']), 0)),
      };

      updatedEntities[discountIndex] = {
        ...updatedEntities[discountIndex],
        value: formatValue(Math.max(Number(updatedEntities[discountIndex]['value']), 0)),
      };

      updatedEntities[adCostIndex] = {
        ...updatedEntities[adCostIndex],
        value: formatValue(Math.max(Number(updatedEntities[adCostIndex]['value']), 0)),
      };

      updatedEntities[promIndex] = {
        ...updatedEntities[promIndex],
        value: formatValue(Math.max(Number(updatedEntities[promIndex]['value']), 0)),
      };
    }

    // Now update the state with the modified array
    setFinancialLevers(updatedEntities);
    setEntities(updatedEntities);


    // setIsLeverChanged(true)
  };

  const toggleFreeze = (index) => {
    const updatedEntities = financialLevers.map((entity, i) =>
      i === index ? { ...entity, frozen: !entity.frozen } : entity
    );
    setFinancialLevers(updatedEntities);
  };

  const durationOptions = [
    { label: 'Months', value: 'Months' },
    { label: 'Quarters', value: 'Quarters' },
    { label: 'Year', value: 'Year' }
  ];

  return (
    <>
      <div className={`flex flex-col shadow-md transition-width duration-300 ${minimize ? 'w-16' : 'w-96'} h-screen bg-custom-sidebar-gradient-ultra-light`}>
        {/* Header Section */}
        {!minimize && (
          <div className="flex items-center justify-between p-3 sticky top-0 z-10">
            <img src={kanerikaLogo} alt="Kanerika Logo" className="w-36" />
            <button
              title={minimize ? 'Maximize Sidebar' : 'Minimize Sidebar'}
              onClick={() => setMinimizeSidebar(!minimize)}
              className="p-2 hover:text-white rounded-full hover:bg-gradient-hover focus:outline-none"
            >
              <ChevronLeftIcon className={`h-6 w-6 ${minimize ? 'rotate-180' : ''}`} />
            </button>
          </div>
        )}

        {/* Toolbar Section */}
        {!minimize && (
          <div className='p-4'>
            {/* What-If Section */}
            <div
              className="cursor-pointer rounded-lg flex justify-between items-center hover:scale-105 transition duration-300 ease-in-out"
              onClick={() => setIsWhatIfExpanded(!isWhatIfExpanded)}
            >
              <p className="text-xl font-semibold text-custom-blue">What-If</p>
              {isWhatIfExpanded ? (
                <ChevronUpIcon className="h-5 w-5 text-gray-600" />
              ) : (
                <ChevronDownIcon className="h-5 w-5 text-gray-600" />
              )}
            </div>
            <div className="flex flex-col p-1 mt-2">
              {isWhatIfExpanded && (
                <>
                  {/* <p className="text-xl font-semibold text-custom-blue mb-4">What-If</p> */}

                  {/* Duration and Financial Target Row */}
                  <div className="grid grid-cols-2 gap-4 items-center">
                    {/* Duration Dropdown */}
                    <div className="flex-1 col-span-3">
                      <label className="block text-sm font-medium text-gray-700 mb-2">Duration</label>
                      {/* <select
                    value={duration}
                    onChange={(e) => setDuration(e.target.value)}
                    className="w-full p-2 border border-gray-300 bg-white rounded-lg shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                  >
                    <option value="Months">Months</option>
                    <option value="Quarters">Quarters</option>
                    <option value="Year">Year</option>
                  </select> */}
                      <select
                        value={duration}
                        onChange={(e) => setDuration(e.target.value)}
                        className="w-full p-2 border border-gray-300 bg-white rounded-lg shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                      >
                        {durationOptions.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Months/Quarters Slider */}
                    <div className="flex-1">
                      <label className="block text-sm font-medium text-gray-700 mb-2 truncate">{duration}</label>
                      {duration !== 'Year' ? (
                        <>
                          <input
                            type="range"
                            min="1"
                            max={duration === 'Months' ? 12 : 4}
                            value={selectedDurationValue}
                            onChange={(e) => setSelectedDurationValue(Number(e.target.value))}
                            className="w-full cursor-pointer accent-custom-purple"
                          />
                          <p>{selectedDurationValue}</p>
                        </>
                      ) : (
                        <p>1</p>
                      )}
                    </div>

                    {/* Financial Target */}
                    <div className="flex-1">
                      <label className="block text-sm font-medium text-gray-700 mb-2 truncate">Financial Target (in %)</label>
                      <input
                        type="range"
                        min="0"
                        max="100"
                        value={financeTarget}
                        onChange={(e) => setFinanceTarget(Number(e.target.value))}
                        className="w-full cursor-pointer accent-custom-purple"
                      />
                      <p>{financeTarget}%</p>
                    </div>
                  </div>
                </>
              )}

            </div>
          </div>
        )}

        {/* Financial Levers Section */}
        {!minimize && (
          <>
            <div
              className="cursor-pointer p-4 rounded-lg flex justify-between items-center hover:scale-105 transition duration-300 ease-in-out"
              onClick={() => setLeversExpanded(!isLeversExpanded)}
            >
              <p className="text-xl font-semibold text-custom-blue">Levers</p>
              {isLeversExpanded ? (
                <ChevronUpIcon className="h-5 w-5 text-gray-600" />
              ) : (
                <ChevronDownIcon className="h-5 w-5 text-gray-600" />
              )}
            </div>
            <div className="p-1 flex-1 overflow-y-auto">


              {isLeversExpanded && (
                <div className="flex-1 space-y-2 p-3">
                  {leversLoading ? (
                    <Loader isLoading={leversLoading} />
                    // <div className="flex justify-center items-center h-64">
                    //   <ScaleLoader size={50} color={'#5a8deb'} loading={leversLoading} />
                    // </div>
                  ) : financialLevers?.length ? (
                    financialLevers?.map((entity, index) => (
                      <div key={index} className="p-3 bg-white rounded-lg shadow-sm mb-2">
                        <div className="flex justify-between items-center space-x-2 mb-1">
                          <p className="text-sm font-medium text-gray-700">{entity.name}</p>
                        </div>
                        {entity?.displayRange && (
                          <input
                            type="range"
                            min={entity?.min}
                            max={entity?.max}
                            value={entity.value}
                            className="w-full accent-custom-purple cursor-pointer"
                            onChange={(e) => handleEntityChange(index, Number(e.target.value), entity.name)}
                            disabled={entity.frozen}
                          />
                        )}
                        <div className="mt-1 flex justify-between">
                          <p className="text-sm">
                            {entity.value} {entity.unit}
                          </p>
                          <button
                            className={`px-2 py-1 rounded-lg text-xs text-white ${!entity.frozen ? 'bg-custom-blue hover:bg-custom-hover-purple' : 'bg-gray-500'
                              }`}
                            onClick={() => toggleFreeze(index)}
                          >
                            {entity.frozen ? 'Unfreeze' : 'Freeze'}
                          </button>
                        </div>
                      </div>
                    ))
                  ) : (
                    <p className="text-xs text-center text-slate-500">No Data Found</p>
                  )}
                </div>
              )}
            </div>

            {/* Footer Buttons */}
            <div className="p-4 sticky bottom-0 w-full ">
              <div className="flex flex-col md:flex-row justify-between items-center space-y-2 md:space-y-0 md:space-x-2">
                <button
                  onClick={onReset}
                  className="w-full md:w-auto px-4 py-2 text-sm rounded hover:text-white hover:bg-gradient-hover text-black"
                >
                  Reset
                </button>
                <button
                  onClick={handleForecast}
                  className="w-full md:w-auto px-4 py-2 rounded text-sm  hover:text-white bg-gradient-45 hover:bg-gradient-hover text-white"
                >
                  Generate Forecast
                </button>
              </div>
            </div>
          </>
        )}

        {/* Minimized Sidebar */}
        {minimize && (
          <div className="flex flex-col justify-start items-center m-2 space-y-4">
            <button
              title="Maximize Sidebar"
              onClick={() => setMinimizeSidebar(!minimize)}
              className="p-2 hover:text-white rounded-full hover:bg-gradient-hover focus:outline-none"
            >
              <ChevronLeftIcon className={`h-6 w-6 ${minimize ? 'rotate-180' : ''}`} />
            </button>
          </div>
        )}
      </div>
      {/* Conditionally render the toast if it's visible */}
      {/* {toast.show && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={() => setToast({ show: false, message: '', type: '' })}
        />
      )} */}
    </>
  );
}

export default Sidebar;
